import { render, staticRenderFns } from "./AccountSettingTaxAndCurrency.vue?vue&type=template&id=951fedc8&"
import script from "./AccountSettingTaxAndCurrency.vue?vue&type=script&lang=js&"
export * from "./AccountSettingTaxAndCurrency.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingTaxAndCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports